<template>
    <div class="tideng-year">
        <!-- 活动标题 -->
        <div v-wechat-title='"提灯春节h5活动"'></div>
        <header :class="'header-login-' + headerLogin">
            <div class="acco">{{ user_info.user_id ? `${user_info.role_name} ${user_info.server_name ?
                `[${user_info.server_name}]` : ''}` : '削得爽的地牢养宠游戏' }}</div>
            <a class="download-btn" title="下载按钮" @click="goOfficeWeb"></a>
            <a v-if="!user_info.user_id" class="logon-btn" @click="logon()" title="登录&切换按钮"></a>
            <a v-else class="switch-btn" @click="switchBtn()"></a>
        </header>
        <!-- 登录弹窗 -->
        <Login v-if='isShowLogin' noAuthLogin v-on:channelCallback='onInit' :gameName="gameName"
            :loginTypes='loginTypes' :downloadUrl='downloadUrl' channelTips='角色UID可在游戏中—设置—UID查看'></Login>

        <!-- 绑定弹窗 -->
        <Os v-if='isShowOs' v-on:selectCallback='onBind()' v-on:logoutCallback='osCancel' :gameName='gameName'></Os>

        <MySwiper :noSwiperClass='noSwiperClass' ref="mySwiper" class="swiper-wrapper_c">
            <template v-slot:first-slide-content>
                <div class='home-page-bc'>
                    <div class="title">
                        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut"
                            name="fade">
                            <img src="https://download4.qcplay.com/qcgame-api/CEnhGXmazxXP5YFgeEgqCn2AOmo1JcOaukaW5elm.png
" />
                        </transition>
                    </div>
                    <div class="rule-btn" @click="topRule">
                        <a></a>
                    </div>
                    <div class="egg-btn" @click="getEggReward">
                        <a></a>
                    </div>
                    <div class="act-btn monitor-btn" :class="{ 'safari-class': isSafari }" @click="nextPage()"
                        data-event="参加活动">
                        <a></a>
                    </div>
                    <div class="arrow"></div>
                </div>
            </template>
            <template v-slot:second-slide-content>
                <div class='content-page'>
                    <div class='active-content'>
                        <div class="fragment-container">
                            <div class="rule-btn" @click="contentRule">
                                <a></a>
                            </div>

                            <div class="activity-time">
                                <p>活动剩余时间: {{ countdown }}</p>
                            </div>

                            <div v-if="!buttonClicked" class="fragment-container-wrapper">
                                <div v-if="currentPieces === 12" class="overlay"></div>
                                <div class="fragment-line"></div>
                                <div v-if="allFragmentsCollected && !buttonClicked" class="hc-btn" @click="hcFragment">
                                </div>
                                <img v-for="index in 12" :key="`fragment-${index}`" :src="getImagePath(index - 1)"
                                    :class="`bright-fragment-item bright-item-${index}`" />
                                <li v-for="(item, index) in map_list" :key="index" class="fragment-item-container"
                                    :class="`fragment-item-container-${index}`">
                                    <span :class="`fragment-num-${index}`" v-if="item !== 1"></span>
                                    <b class="fragment-item" :class="`fragment-item-${index}`" :style="{
                                        backgroundImage: `url(${getImagePath(index, item)})`,
                                        display: 'block',
                                        backgroundSize: 'cover',
                                        filter: item === 0 ? 'brightness(0.35)' : 'none'
                                    }"></b>
                                </li>
                            </div>
                            <div v-else class="allFragment-container-wrapper">
                                <div @click="look" class="look"></div>
                            </div>

                            <div class="fragment-count">
                                <p>当前解锁碎片: {{ currentPieces }}/12</p>
                            </div>

                            <div class="progress-container">
                                <div class="progress">
                                    <div class="progress-dynamic"></div>
                                </div>
                                <div class="reward-item">
                                    <div v-for="(reward, index) in rewards" :key="index" :class="[
                                        'reward-' + index,
                                        {
                                            active: currentPieces >= reward.number,
                                            shake: !reward.is_get && currentPieces >= reward.number,
                                            gettable: reward._get,
                                            dimmed: reward.is_get // 添加 dimmed 类
                                        }
                                    ]" @click="showPopup(reward)">
                                        <div v-if="reward.is_get" class="checkmark-overlay"></div>
                                    </div>
                                </div>
                                <div class="fragment-item">
                                    <div v-for="(fragment, index) in rewards" :key="index"
                                        :class="['fragment-' + index, { active: currentPieces >= fragment.number }]">
                                    </div>
                                </div>
                            </div>

                            <div class="button-container">
                                <div v-if="!buttonClicked" class="share-fragment" @click="shareFragmentClick"><a></a>
                                </div>
                                <div v-else class="share-fragment-do" @click="shareToast"><a></a>
                                </div>
                                <div v-if="!buttonClicked" class="get-fragment" @click="getFragmentClick"><a></a></div>
                                <div v-else class="get-fragment-do" @click="getToast"><a></a></div>
                            </div>
                        </div>
                        <div class="reward-main" :class="{ 'safari-class': isSafari }">
                        </div>
                    </div>
                </div>
            </template>
        </MySwiper>

        <!-- 注销弹窗 -->
        <div class="logout-wrap popup_wrap" v-show="logoutShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="logout-box popup_wrap-box" v-show="logoutShow">
                    <p>是否退出当前账号</p>
                    <a class="left-btn" href="javascript:;" @click="logoutShow = false">取消</a>
                    <a class="right-btn" href="javascript:;" @click="logoutBtn()">确定</a>
                </div>
            </transition>
        </div>

        <!-- 弹窗 -->
        <!-- 活动详情弹窗 -->
        <div class="rule-wrap popup_wrap" v-show="ruleShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="rule-wrap-box popup_wrap-box" v-show="ruleShow">
                </div>
            </transition>
            <div class="close-bg" @click="popSwitch('ruleShow', false)"></div>
        </div>

        <!-- 彩蛋弹窗 -->
        <div class="egg-wrap popup_wrap" v-show="eggShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="egg-wrap-box popup_wrap-box" v-show="eggShow">
                </div>
            </transition>
            <div class="close-bg" @click="popSwitch('eggShow', false)"></div>
        </div>

        <!-- 全家福弹窗反转动效 -->

        <div class="all-fragment-wrap popup_wrap" v-show="allFragmentShow || lookFragmentShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="flip" :class="{ flipped: isFlipped }">
                    <div class="all-fragment-wrap-box popup_wrap-box" v-show="!isFlipped">
                        <!-- 全家福内容 -->
                        <div class="switch" v-if="lookFragmentShow" @click="toggleFlip"></div>
                    </div>
                    <div class="festival-one-box popup_wrap-box" v-show="isFlipped">
                        <div class="text-container" v-if="gameTime > 0">
                            <div class="p1">
                                <p>亲爱的提灯者：</p>
                            </div>
                            <div class="p2">
                                <p>嘿，新年又到啦！</p>
                            </div>
                            <div class="p3">
                                <p>过去的一年你有开开心心的度过吗~算算时日，你我相伴已有<span class="day-time">{{ gameTime
                                        }}天</span>，一路上，多谢关照！在过去的一年中，前台甲和团队反复battle，想给大家多些福利，少点爆肝。一路走来，我们也听到了很多提灯者的声音，所以我们决定生命不息，折腾不止，持续捣鼓新内容中！最后，一点小礼物，送给依然热忱的你~
                                </p>
                            </div>
                        </div>
                        <div class="text-container" v-else="gameTime > 0">
                            <div class="p1">
                                <p>亲爱的提灯者：</p>
                            </div>
                            <div class="p2">
                                <p>嘿，新年又到啦！</p>
                            </div>
                            <div class="p3">
                                <p>过去的一年你有开开心心的度过吗~你我相伴的日子里，多谢关照！在过去的一年中，前台甲和团队反复battle，想给大家多些福利，少点爆肝。一路走来，我们也听到了很多提灯者的声音，所以我们决定生命不息，折腾不止，持续捣鼓新内容中！最后，一点小礼物，送给依然热忱的你~
                                </p>
                            </div>
                        </div>
                        <div class="switch" v-if="lookFragmentShow" @click="toggleFlip"></div>
                        <div v-if="!isFinish" @click="clickGetReward" class="get-reward"></div>
                        <div v-else class="finish-reward"></div>
                    </div>
                </div>
            </transition>
            <div class="close-bg" @click="closePopup"></div>
        </div>

        <div class="all1-fragment-wrap popup_wrap" v-show="allFragmentShow1 || lookFragmentShow1">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="flip1" :class="{ flipped1: isFlipped1 }">
                    <div class="all-fragment-wrap-box popup_wrap-box" v-show="!isFlipped1">
                        <!-- 全家福内容 -->
                        <div class="switch" v-if="lookFragmentShow1" @click="toggleFlip1"></div>
                    </div>
                    <div class="festival-two-box popup_wrap-box" v-show="isFlipped1">
                        <div class="text-container" v-if="gameTime > 0">
                            <div class="p1">
                                <p>亲爱的提灯者：</p>
                            </div>
                            <div class="p2">
                                <p>嘿，新年又到啦！</p>
                            </div>
                            <div class="p3">
                                <p>过去的一年你有开开心心的度过吗~算算时日，你我相伴已有<span class="day-time">{{ gameTime
                                        }}天</span>，一路上，多谢关照！在过去的一年中，前台甲和团队反复battle，想给大家多些福利，少点爆肝。一路走来，我们也听到了很多提灯者的声音，所以我们决定生命不息，折腾不止，持续捣鼓新内容中！最后，一点小礼物，送给依然热忱的你~
                                </p>
                            </div>
                        </div>
                        <div class="text-container" v-else>
                            <div class="p1">
                                <p>亲爱的提灯者：</p>
                            </div>
                            <div class="p2">
                                <p>嘿，新年又到啦！</p>
                            </div>
                            <div class="p3">
                                <p>过去的一年你有开开心心的度过吗~你我相伴的日子里，多谢关照！在过去的一年中，前台甲和团队反复battle，想给大家多些福利，少点爆肝。一路走来，我们也听到了很多提灯者的声音，所以我们决定生命不息，折腾不止，持续捣鼓新内容中！最后，一点小礼物，送给依然热忱的你~
                                </p>
                            </div>
                        </div>
                        <div class="switch" v-if="lookFragmentShow1" @click="toggleFlip1"></div>
                    </div>
                </div>
            </transition>
            <div class="close-bg" @click="closePopup1"></div>
        </div>

        <!-- 任务弹窗 -->
        <div class="task-wrap popup_wrap" v-show="taskListShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="task-wrap-box popup_wrap-box" v-show="taskListShow">
                    <div :class="`item item-${item.status}`" v-for="(item, index) in task_list" :key="index"
                        @click="handleClick(item.id, item.link)"></div>
                </div>
            </transition>
            <div class="close-bg" @click="closeTaskList"></div>
        </div>


        <!-- 领取别人分享的碎片弹窗  -->
        <div class="user-share-fragment-wrap popup_wrap" v-show="userShareShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="user-share-fragment-wrap-box popup_wrap-box" v-show="userShareShow">
                    <div class="fragment-info">
                        <p>其他提灯者向你分享了<span>{{ otherFragment }}</span>号拼图碎片！</p>
                    </div>
                    <div class="fragments-wrapper" v-if="otherFragment">
                        <div class="fragments-container">
                            <div class="fragment-item">
                                <div :class="`fragment-image fragment-${otherFragment}`"></div>
                            </div>
                        </div>
                    </div>
                    <div @click="getShareFragment" class="get-fragment"></div>
                </div>
            </transition>
            <div class="close-bg" @click="popSwitch('userShareShow', false)"></div>
        </div>

        <!-- 领取碎片弹窗 单个的 -->
        <div class="get-one-fragment-wrap popup_wrap" v-show="getOneFragmentShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="get-one-fragment-wrap-box popup_wrap-box" v-show="getOneFragmentShow">
                    <div class="fragment-info">
                        <p>恭喜获得<span>{{ oneFragment[0] }}</span>号拼图碎片！</p>
                    </div>
                    <div class="fragments-wrapper" v-if="oneFragment.length > 0">
                        <div class="fragments-container">
                            <div v-for="(fragment, index) in oneFragment" :key="index" class="fragment-item">
                                <div :class="`fragment-image fragment-${fragment}`"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <div class="close-bg" @click="popSwitch('getOneFragmentShow', false)"></div>
        </div>

        <!-- 领取碎片弹窗 两个的 -->
        <div class="get-two-fragment-wrap popup_wrap" v-show="getTwoFragmentShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="get-two-fragment-wrap-box popup_wrap-box" v-show="getTwoFragmentShow">
                    <div class="fragment-info">
                        恭喜获得
                        <span v-for="(fragment, index) in twoFragment" :key="index">
                            <span class="frag-num">{{ fragment }}</span>号
                            <span v-if="index < twoFragment.length - 1">、</span>
                        </span>
                        拼图碎片！
                    </div>

                    <div class="fragments-wrapper" v-if="twoFragment.length > 0">
                        <div v-for="(fragment, index) in twoFragment" :key="index"
                            :class="`fragment-item fragment-item-${index}`">
                            <div :class="`fragment-image fragment-${fragment}`"></div>
                        </div>
                    </div>
                </div>
            </transition>
            <div class="close-bg" @click="popSwitch('getTwoFragmentShow', false)"></div>
        </div>

        <!-- 碎片发光弹窗 -->
        <div class="light-fragment-wrap popup_wrap1" v-show="lightFragmentShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="light-fragment-wrap-box popup_wrap-box" v-show="lightFragmentShow">
                    <div class="fragment-container-wrapper">

                        <div class="fragment-line"></div>
                        <li @click="handleFragmentClick(item, index)" v-for="(item, index) in new_map_list" :key="index"
                            class="fragment-item-container" :class="`lihgt-fragment-item-container-${index}`">
                            <span :class="`fragment-num-${index}`" v-if="item !== 1"></span>
                            <b class="fragment-item" :class="`fragment-item-${index} ${item === 1 ? 'breathing' : ''}`"
                                :style="{
                                    backgroundImage: `url(${getImagePath(index, item)})`,
                                    display: 'block',
                                    backgroundSize: 'cover',
                                    filter: item === 0 ? 'brightness(0.35)' : 'none'
                                }"></b>
                        </li>
                    </div>
                </div>
            </transition>
            <div class="close-bg" @click="popSwitch('lightFragmentShow', false)"></div>
        </div>

        <!-- 分享碎片弹窗 -->
        <div class="share-fragment-wrap popup_wrap" v-show="shareFragmentShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="share-fragment-wrap-box popup_wrap-box" v-show="shareFragmentShow">
                    <img :class="`cur-${currentFragmentIndex}`" :src="currentFragmentImage" alt="碎片图片" />
                    <p class="fragment-info">分享<span>{{ currentFragmentIndex + 1 }}</span>号碎片给朋友</p>
                    <div class="clipboard-btn" @click="copyLink('.clipboard-btn')" data-event="复制活动链接"
                        :data-clipboard-text="`风息要塞的小伙伴给你赠送拼图碎片啦！解锁拼图拿免费福利，还能发现更多隐藏惊喜哦！快来领取吧~：https://h5.qingcigame.com/tideng/year/enter?code=${shareCode}`">
                    </div>
                </div>
            </transition>
            <div class="close-bg" @click="popSwitch('shareFragmentShow', false)"></div>
        </div>

        <!-- 2个碎片奖励 -->
        <div class="two-fragment-wrap popup_wrap" v-show="twoFragmentShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="two-fragment-wrap-box popup_wrap-box" v-show="twoFragmentShow">
                </div>
            </transition>
            <div class="close-bg" @click="popSwitch('twoFragmentShow', false)"></div>
        </div>

        <!-- 2个碎片奖励 -->
        <div class="gif-wrap popup_wrap1" v-show="gifShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="gif-wrap-box popup_wrap-box" v-show="gifShow">
                </div>
            </transition>
            <!-- <div class="close-bg" @click="popSwitch('gifShow', false)"></div> -->
        </div>


        <!-- 4个碎片奖励 -->
        <div class="four-fragment-wrap popup_wrap" v-show="fourFragmentShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="four-fragment-wrap-box popup_wrap-box" v-show="fourFragmentShow">
                </div>
            </transition>
            <div class="close-bg" @click="popSwitch('fourFragmentShow', false)"></div>
        </div>

        <!-- 7个碎片奖励 -->
        <div class="seven-fragment-wrap popup_wrap" v-show="sevenFragmentShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="seven-fragment-wrap-box popup_wrap-box" v-show="sevenFragmentShow">
                </div>
            </transition>
            <div class="close-bg" @click="popSwitch('sevenFragmentShow', false)"></div>
        </div>

        <!-- 10个碎片奖励 -->
        <div class="ten-fragment-wrap popup_wrap" v-show="tenFragmentShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="ten-fragment-wrap-box popup_wrap-box" v-show="tenFragmentShow">
                </div>
            </transition>
            <div class="close-bg" @click="popSwitch('tenFragmentShow', false)"></div>
        </div>

        <!-- 12个碎片奖励 -->
        <div class="twelve-fragment-wrap popup_wrap" v-show="twelveFragmentShow">
            <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
                :duration="{ enter: 1000 }">
                <div class="twelve-fragment-wrap-box popup_wrap-box" v-show="twelveFragmentShow">
                </div>
            </transition>
            <div class="close-bg" @click="popSwitch('twelveFragmentShow', false)"></div>
        </div>

        <!-- 全局遮罩 -->
        <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
    </div>
</template>
<script>
import { Toast } from 'mint-ui';
import Clipboard from 'clipboard';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Footer from '@/components/Footer';
import MySwiper from '@/components/MySwiper';
import { LogoutAPI } from "@/api/login";
import { onInitAPI, onEggRewardAPI, onGetShareReward, onGetRewardFragment, getShareCode, initShareLink, getFragmentReward, getOtherFragment } from "../api"
import { getTimeStamp, buriedLogger, analysisParams } from '@/utils/utils';
export default {
    name: 'year',
    components: {
        Footer,
        Login,
        Os,
        MySwiper
    },

    data() {
        return {
            disableInteraction: false, // 用于禁用交互
            gifShow: false,
            oneFragment: [],
            twoFragment: [],
            isSafari: false,
            isRequesting: false, // 用于锁机制
            has_card: [], // 拥有碎片数量
            otherFragment: '', // 别人分享的是几号碎片
            shareCode: '', // 分享码
            fragmentNum: '',// 从分享链接获取到的碎片
            shareLink: "",
            buttonClicked: false, // 立即合成是否被点击过
            isFinish: false,// 新春寄语奖励是否领取
            isFlipped: false, // 反转动效
            isFlipped1: false, // 反转动效
            gameTime: '', // 游戏时间
            rewards: [2, 4, 7, 10, 12],
            map_list: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 碎片
            new_map_list: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            fragments: [], // 存储领取之后获得的碎片
            gameName: 'tideng',
            downloadUrl: 'https://static.qcplay.com/tideng/official/',
            userShareShow: false, // 用户分享
            ruleShow: false, // 活动详情弹窗
            eggShow: false, // 彩蛋弹窗
            getOneFragmentShow: false, // 领取一个碎片弹窗
            getTwoFragmentShow: false, // 领取两个碎片弹窗
            taskListShow: false, // 任务列表弹窗
            lightFragmentShow: false, // 发光碎片弹窗
            shareFragmentShow: false, // 分享碎片弹窗
            twoFragmentShow: false, // 2个碎片奖励弹窗
            fourFragmentShow: false, // 4个碎片奖励弹窗
            sevenFragmentShow: false, // 7个碎片奖励弹窗
            tenFragmentShow: false, // 10个碎片奖励弹窗
            twelveFragmentShow: false, // 12个碎片奖励弹窗
            allFragmentShow: false, // 全家福
            allFragmentShow1: false, // 领取奖励后的
            lookFragmentShow1: false, // 领取奖励后的
            lookFragmentShow: false, // 点击查看图标显示的弹窗
            currentFragmentIndex: null, // 碎片下标
            currentFragmentImage: '', // 目前分享的碎片图片
            user_info: {}, // 用户信息
            countdown: '',
            task_list: ['', '', ''], // status：0去完成，1领取，2已完成
            logger: null,
            titleShow: false,
            headerLogin: false,
            noSwiperClass: '', // swiper-no-swiping
            logoutShow: false,
            // 全屏遮罩
            preventShow: false,
            loginTypes: ["sms", "password", "channel"],
            claimedRewards: []
        };
    },
    created() {
        // 清空store上的用户数据
        this.setInitActiveInfo()
        this.setInitUserInfo()
        // 埋点
        const bl = buriedLogger('tideng', '提灯春节h5活动');
        this.logger = bl
        // safari下底部被遮住
        if ((/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) && !/EdgiOS/.test(navigator.userAgent)) {
            this.isSafari = true;
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.monitoringEquipment();
            this.mySwiper()
            // 检查 localStorage 中的按钮状态
            this.onInit()
            this.$nextTick(() => {
                var linkUrl = 'https://h5.qingcigame.com/tideng/year/enter';
                this.isSetShare(linkUrl);
                // 计算倒计时
                this.updateCountdown();
                setInterval(this.updateCountdown, 1000);
            })
        })
    },
    watch: {
        currentPieces() {
            this.updateProgress();
        },
    },
    computed: {
        currentPieces() {
            return this.map_list.filter(piece => piece === 1).length;
        },
        // 显示合成按钮
        allFragmentsCollected() {
            return this.map_list.every(value => value === 1);
        },
        ...mapState([
            'userInfo',
            'activeInfo',
            'isShowLogin',
            'isShowOs'
        ])
    },
    methods: {
        handleFragment(task_id) {
            return onGetRewardFragment({ app_id: 33, task_id }).then((response) => {
                if (Number(response.code) === 200) {
                    this.fragments = this.fragments.concat(response.data.card_id);
                    if (response.data.card_id.length === 1) {
                        this.oneFragment = response.data.card_id
                    } else {
                        this.twoFragment = response.data.card_id
                    }
                    if (response.data.card_id.length === 1) {
                        this.getOneFragmentShow = true;
                    } else {
                        this.getTwoFragmentShow = true;
                    }
                    this.onInit(false, false);
                    this.logger.sum('提灯春节h5活动_每个任务领取数');
                }
            });
        },
        handleReward(task_id) {
            return onGetShareReward({ app_id: 33, task_id }).then((response) => {
                if (Number(response.code) === 200) {
                    this.onInit(false, false);
                } else {
                    this.onToast(response.message);
                }
            });
        },
        handleClick(id, link) {
            if (this.isRequesting) return;
            this.onTask(id, link);
        },
        monitoringEquipment() {
            if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = `https://h5.qingcigame.com/tideng/year/pc${getTimeStamp()}`
        },
        contentRule() {
            this.logger.sum('提灯春节h5活动_活动页活动详情按钮')
            this.ruleShow = true
        },
        topRule() {
            this.logger.sum('提灯春节h5活动_首页活动详情按钮')
            this.ruleShow = true
        },
        shareFragmentClick() {
            this.logger.sum('提灯春节h5活动_分享碎片按钮')
            if (!this.checkLogin()) return
            if (this.currentPieces > 0) {
                this.lightFragmentShow = true
            } else {
                this.onToast('您当前的碎片不足')
            }
        },
        getFragmentClick() {
            this.logger.sum('提灯春节h5活动_获取碎片按钮')
            if (!this.checkLogin()) return
            this.taskListShow = true
        },
        updateProgress() {
            const widthMap = {
                3: '5%',
                4: '10%',
                5: '33%',
                6: '36%',
                7: '39.5%',
                8: '61.5%',
                9: '65.5%',
                10: '69%',
                11: '93.5%',
                12: '100%'
            };

            const progressElement = document.querySelector('.progress-dynamic');
            const width = widthMap[this.currentPieces] || '0';

            progressElement.style.width = width;
        },
        // 领取彩蛋奖励
        getEggReward() {
            if (!this.checkLogin()) return
            onEggRewardAPI({
                app_id: 33
            }).then((response) => {
                if (Number(response.code) === 200) {
                    this.eggShow = true
                    this.onInit()
                    this.logger.sum('提灯春节h5活动_首页彩蛋灯按钮')
                } else {
                    this.onToast(response.message)
                }
            })
        },
        nextPage() {
            this.logger.sum('提灯春节h5活动_参与活动按钮')
            if (!this.checkLogin()) return
            this.$refs.mySwiper.nextSwiper(1);
        },
        getShareFragment() {
            getOtherFragment({
                app_id: 33,
                code: this.shareCode
            }).then(response => {
                if (Number(response.code == 200)) {
                    this.animateFragment(this.otherFragment);
                    this.userShareShow = false
                    this.onToast("领取成功！")
                } else {
                    this.onToast(response.message)
                }
            })
        },
        // 登录校验
        checkLogin() {
            if (!this.user_info.user_id) {
                this.changeLoginPopup(true)
                this.onToast('请先登录')
                return false
            }
            return true
        },
        toggleFlip() {
            this.logger.sum('提灯春节h5活动_切换图标按钮')
            this.isFlipped = !this.isFlipped;
        },
        toggleFlip1() {
            this.logger.sum('提灯春节h5活动_切换图标按钮')
            this.isFlipped1 = !this.isFlipped1;
        },
        closePopup() {
            if (!this.disableInteraction) {
                // 关闭弹窗逻辑
                this.allFragmentShow = false;
                this.lookFragmentShow = false;
                this.isFlipped = false
            }
        },
        async getShareLink(code) {
            await initShareLink({
                app_id: 33,
                code
            }).then(response => {
                if (Number(response.code == 200)) {
                    this.logger.sum('提灯春节h5活动_分享领取按钮')
                    this.otherFragment = response.data.card_info
                    this.userShareShow = true
                } else {
                    this.onToast(response.message)
                }
            })
        },
        closePopup1() {
            this.allFragmentShow1 = false;
            this.lookFragmentShow1 = false;
            this.isFlipped1 = false;
        },
        look() {
            this.logger.sum('提灯春节h5活动_查看图标按钮')
            if (!this.isFinish) {
                this.lookFragmentShow = true;
            } else {
                this.isFlipped1 = false;
                this.lookFragmentShow1 = true;
            }
        },
        shareToast() {
            this.logger.sum('提灯春节h5活动_分享碎片按钮')
            this.onToast('你已完成拼图~');
        },
        getToast() {
            this.logger.sum('提灯春节h5活动_获取碎片按钮')
            this.onToast('你已参与过活动啦~')
        },
        // 点击立即合成
        hcFragment() {
            this.logger.sum('提灯春节h5活动_立即合成按钮')
            this.gifShow = true
            this.buttonClicked = true;
            setTimeout(() => {
                this.gifShow = false
            }, 4900);
            setTimeout(() => {
                this.allFragmentShow = true;
                this.isFlipped = false;
                // 更新按钮点击状态
                localStorage.setItem(`${this.userInfo.rid}`, this.userInfo.rid)
                // 禁用交互
                this.disableInteraction = true;
                setTimeout(() => {
                    this.isFlipped = true;
                    // 1.5秒后重新启用交互
                    this.disableInteraction = false;
                }, 1500); // 1.5秒后翻转
            }, 4900);
        },
        // 这个是全家福出现后收下新春奖励的逻辑
        clickGetReward() {
            // 合成的传13
            getFragmentReward({
                app_id: 33,
                type: 13
            }).then(response => {
                if (Number(response.code) === 200) {
                    var otherOpt = false
                    this.onInit(otherOpt)
                    this.logger.sum('提灯春节h5活动_收下礼物按钮')
                    this.onToast("领取成功！请在游戏内查收~")
                } else {
                    this.onToast(response.message)
                }
            })
        },
        showPopup(reward) {
            if (!this.checkLogin()) return;

            if (reward.number > this.currentPieces) {
                this.onToast('碎片数不足，快去获取碎片吧~');
                return;
            }

            if (reward._get && !reward.is_get) {
                getFragmentReward({
                    app_id: 33,
                    type: reward.number
                }).then(response => {
                    if (Number(response.code) === 200) {
                        this.onInit(false);
                        reward.is_get = true; // 更新奖励状态
                        this.showRewardPopup(reward.number);
                    } else {
                        this.onToast(response.message);
                    }
                });
            } else {
                this.onToast('很抱歉,该奖励已领取!');
            }
        },
        showRewardPopup(number) {
            const rewardMap = {
                2: 'twoFragmentShow',
                4: 'fourFragmentShow',
                7: 'sevenFragmentShow',
                10: 'tenFragmentShow',
                12: 'twelveFragmentShow'
            };

            if (rewardMap[number]) {
                this[rewardMap[number]] = true;
                this.logger.sum('提灯春节h5活动_进度条每档礼包领取');
            }
        },

        // 复制链接
        copyLink(copyName) {
            var _this = this
            const clipboard = new Clipboard(copyName)
            clipboard.on('success', (e) => {
                _this.onToast('复制成功')
                e.clearSelection()
                this.logger.sum('提灯春节h5活动_复制成功')
            })
            clipboard.on('error', (e) => {
                _this.onToast('复制失败')
            })
        },
        handleFragmentClick(item, index) {
            if (item === 0) {
                this.onToast("该碎片还未点亮，快去收集吧~");
            } else {
                this.currentFragmentIndex = index;
                this.currentFragmentImage = this.getBorderImagePath(index);
                getShareCode({
                    app_id: 33,
                    card_id: this.currentFragmentIndex + 1
                }).then(response => {
                    this.logger.sum('提灯春节h5活动_亮起的碎片的点击数')
                    this.shareCode = response.data.code
                })
                this.popSwitch('shareFragmentShow', true);
            }
        },
        closeTaskList() {
            this.taskListShow = false;
            this.fragments = Array.from(new Set(this.fragments)); // 去重
            this.fragments.forEach(fragment => {
                this.animateFragment(fragment);
            });
            // 动画完成后清空碎片数组
            this.fragments = [];
        },
        animateFragment(fragmentIndex) {
            const fragmentElement = document.querySelector(`.bright-item-${fragmentIndex}`);
            if (fragmentElement) {
                fragmentElement.classList.add('show');
                // 过几秒钟后移除 'show' 类
                setTimeout(() => {
                    fragmentElement.classList.remove('show');
                }, 1500);
            }
            setTimeout(() => {
                var otherOpt = false
                this.onInit(otherOpt)
            }, 1000);
        },
        getImagePath(index) {
            const images = [
                'https://download4.qcplay.com/tideng/year/home/01.png',
                'https://download4.qcplay.com/tideng/year/home/02.png',
                'https://download4.qcplay.com/tideng/year/home/03.png',
                'https://download4.qcplay.com/tideng/year/home/04.png',
                'https://download4.qcplay.com/tideng/year/home/05.png',
                'https://download4.qcplay.com/tideng/year/home/06.png',
                'https://download4.qcplay.com/tideng/year/home/07.png',
                'https://download4.qcplay.com/tideng/year/home/08.png',
                'https://download4.qcplay.com/tideng/year/home/09.png',
                'https://download4.qcplay.com/tideng/year/home/10.png',
                'https://download4.qcplay.com/tideng/year/home/11.png',
                'https://download4.qcplay.com/tideng/year/home/12.png',
            ];

            // 直接根据 index 返回图片
            return images[index];
        },
        getBorderImagePath(index) {
            const images = [
                'https://download4.qcplay.com/tideng/year/home/b_1.png',
                'https://download4.qcplay.com/tideng/year/home/b_2.png',
                'https://download4.qcplay.com/tideng/year/home/b_3.png',
                'https://download4.qcplay.com/tideng/year/home/b_4.png',
                'https://download4.qcplay.com/tideng/year/home/b_5.png',
                'https://download4.qcplay.com/tideng/year/home/b_6.png',
                'https://download4.qcplay.com/tideng/year/home/b_7.png',
                'https://download4.qcplay.com/tideng/year/home/b_8.png',
                'https://download4.qcplay.com/tideng/year/home/b_9.png',
                'https://download4.qcplay.com/tideng/year/home/b_10.png',
                'https://download4.qcplay.com/tideng/year/home/b_11.png',
                'https://download4.qcplay.com/tideng/year/home/b_12.png',
            ];

            // 直接根据 index 返回图片
            return images[index];
        },
        onTask(task_id, itemLink) {
            if (!this.checkLogin()) return;

            const status = this.task_list[task_id - 1].status;
            switch (status) {
                case 0:
                    if (task_id === 1) {
                        this.onToast('请前往游戏完成任务');
                    } else if (task_id === 3) {
                        this.isRequesting = true;
                        setTimeout(() => {
                            this.handleReward(task_id).then(() => {
                                this.isRequesting = false;
                            }).catch(() => {
                                this.isRequesting = false;
                            });
                        }, 3000);
                        this.goLink(itemLink);
                    } else if (task_id === 2) {
                        if (this.has_card.length === 0) {
                            this.onToast('您当前的碎片不足');
                            return;
                        }
                        this.lightFragmentShow = true;
                        this.isRequesting = true;
                        setTimeout(() => {
                            this.handleReward(task_id).then(() => {
                                this.isRequesting = false;
                            }).catch(() => {
                                this.isRequesting = false;
                            });
                        }, 3000);
                    }
                    break;
                case 1:
                    this.isRequesting = true;
                    this.handleFragment(task_id).then(() => {
                        this.isRequesting = false;
                    }).catch(() => {
                        this.isRequesting = false;
                    });
                    break;
                case 2:
                    this.onToast(task_id === 1 || task_id === 2 ? "今日任务已完成，明天再来吧~" : "该任务已完成~");
                    break;
            }
        },
        logon() {
            this.changeLoginPopup(true);
        },
        switchBtn() {
            if (this.userInfo.os == 'bilibili') {
                this.logoutShow = true
            } else {
                this.changeOsPopup(true)
            }
        },
        logoutBtn() {
            LogoutAPI().then((response) => {
                if (Number(response.code) === 200) {
                    // 清空数据 控制弹窗
                    window.localStorage.setItem("access_token", "");
                    this.osCancel()
                    this.logoutShow = false
                    this.setInitUserInfo();
                    this.setInitActiveInfo();
                    this.changeLoginPopup(true);
                }
            });
        },
        // 注销
        osCancel() {
            // this.setInitUserInfo()
            this.user_info = {}
            this.headerLogin = false
            this.otherFragment = ''
            this.shareCode = ''
            this.fragmentNum = ''
            this.shareLink = ""
            this.buttonClicked = false// 立即合成是否被点击过
            this.isFinish = false// 新春寄语奖励是否领取
            this.isFlipped = false // 反转动效
            this.isFlipped1 = false // 反转动效
            this.gameTime = ''// 游戏时间
            this.rewards = [2, 4, 7, 10, 12]
            this.map_list = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] // 碎片
            this.fragments = [] // 存储领取之后获得的碎片
            const progressElement = document.querySelector('.progress-dynamic');
            progressElement.style.width = '0';
            // 清除特定元素的.show类
            const fragmentElements = document.querySelectorAll('.bright-fragment-item.show');
            fragmentElements.forEach(element => {
                element.classList.remove('show');
            });
        },
        onBind() {
            // 切换账号
            this.onInit()
        },
        isSetShare(linkUrl) {
            this.setShare({
                link: linkUrl + `${getTimeStamp()}`,
                title: '提灯与地下城 | 暖灯献礼',
                imgUrl:
                    'https://download4.qcplay.com/qcgame-api/m8A34pYzEDVCvMCFqyOqfiIIOgpuPGgG8pgVMugS.png',
                desc: '解锁拼图拿奖励，福利多多送不停！大事将近，等你提灯喔~',
            })
        },
        // 初始化
        onInit(otherOpt = true, noUpdate = true) {
            var opt = otherOpt
            var noUp = noUpdate
            onInitAPI({
                app_id: 33
            }).then((response) => {
                const params = analysisParams(window.location.href);
                this.shareCode = params.code;
                if (Number(response.code) === 200) {
                    this.noSwiperClass = '';
                    this.headerLogin = true
                    this.onInitDataCallback(response)
                    this.setUserInfo(response.data.userInfo)
                    this.user_info = response.data.userInfo
                    this.task_list = response.data.activity.task_info // 任务列表
                    this.isFinish = response.data.activity.new_year_reward
                    this.gameTime = response.data.activity.number
                    this.has_card = response.data.activity.has_card
                    this.new_map_list = response.data.activity.card_status
                    if (this.userInfo.rid == JSON.parse(window.localStorage.getItem(
                        `${this.userInfo.rid}`
                    ))) {
                        this.buttonClicked = true
                    } else {
                        this.buttonClicked = false
                    }
                    // 默认要更新，但是任务不更新碎片状态,走完动画再同步更新
                    if (noUp) {
                        this.map_list = response.data.activity.card_status
                    }
                    this.rewards = response.data.activity.reward_info
                    if (this.checkLogin() && this.shareCode && opt) {
                        this.$refs.mySwiper.nextSwiper(1);
                        this.getShareLink(this.shareCode)
                    }
                    return
                } else {
                    Number(response.code) !== 401 && this.onToast(response.message)
                    if (this.shareCode) {
                        this.$refs.mySwiper.nextSwiper(1);
                        if (!this.checkLogin()) return
                    }
                }
            })
        },

        goOfficeWeb() {
            setTimeout(() => {
                window.location = this.downloadUrl;
            }, 250);
        },

        mySwiper() {
            this.$refs.mySwiper.init();
        },
        popSwitch(name, state) {
            this[name] = state;
        },

        updateCountdown() {
            const endTime = new Date('2025/02/07 23:59:59');
            const startTime = new Date('2025/01/23 12:00:00');
            const currentTime = new Date();
            if (currentTime < startTime) {
                this.countdown = '活动未开始';
            } else if (currentTime <= endTime) {
                const timeDiff = endTime - currentTime;
                const seconds = Math.floor((timeDiff / 1000) % 60);
                const minutes = Math.floor((timeDiff / 1000 / 60) % 60);
                const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
                const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

                this.countdown = `${days}天${hours}时${minutes}分${seconds}秒`;
            } else {
                this.countdown = '活动已结束';
            }
        },

        // 前往重定向
        goLink(url) {
            if (url === '') return
            setTimeout(() => { window.open(url, '_blank') }, 200)
        },
        // TAG: 其他简易封装的方法
        onToast(config) {
            const curConfig = {
                duration: 1000,
                className: 'toasts'
            };
            if (!config) {
                console.error('缺少config参数');
                return false;
            }
            if (typeof config === 'string') {
                curConfig.message = config;
            }
            Toast(curConfig);
        },

        ...mapMutations([
            'changeLoginPopup',
            'changeOsPopup',
            'setInitActiveInfo',
            'setUserInfo',
            'setInitUserInfo',
            'setLogger'
        ]),
        ...mapActions([
            'onInitDataCallback',
            'onCount',
            'setShare'
        ])
    },
};
</script>
<style lang='less' scoped>
@import url('./index.less');
</style>


// WEBPACK FOOTER //
// src/pages/tideng/year/index/index.vue